import { EnvironmentNames } from "@origin-digital/platform-enums";
import { FeatureFlags } from "@origin-digital/feature-flags";

// Available list of TAL feature flags, please use camelCase for future flags
export const FEATURE_FLAGS = {
  PROPERTY_SELECTOR: "talPropertySelector",
  TOKEN_SHIELD: "tal_token_shield",
} as const;

// String Literal Union of all possible features. Created for convenient/clearer inferred typing
type Feature = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];

export const defaultFeatures: Record<Feature, boolean> = {
  [FEATURE_FLAGS.PROPERTY_SELECTOR]: false,
  [FEATURE_FLAGS.TOKEN_SHIELD]: true,
};

const envFeatureOverrides: Partial<
  Record<EnvironmentNames, Partial<Record<Feature, boolean>>>
> = {
  staging: {},
  prod: {},
};

export const getDefaultFeatures = (env?: EnvironmentNames): FeatureFlags => {
  return { ...defaultFeatures, ...(env ? envFeatureOverrides[env] : {}) };
};
